import { type RouteRecordRaw } from 'vue-router';

import { License } from '../../models';

export const digitalSignageRoutes: RouteRecordRaw[] = [{
    path: 'digital-signage/content',
    name: 'content',
    redirect: { name: 'content.loops' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 2,
        index: 1,
        licenses: {
            operator: 'and',
            licenses: [License.SPOT_VIDEO]
        },
        prependIcon: 'icon-wireless',
        code: 'core.routes.menu.content'
    },
    component: () => import('./views/ContentView.vue'),
    children: [{
        path: 'loops/:loopId',
        name: 'content.loop',
        meta: {
            index: 0,
            code: 'core.routes.content.loop',
            breadcrumbs: true
        },
        component: () => import('./views/content/LoopView.vue')
    }, {
        path: 'children/:loopId',
        name: 'content.children-loop',
        meta: {
            index: 0,
            code: 'core.routes.content.children-loop',
            breadcrumbs: true
        },
        component: () => import('./views/content/ChildrenLoopView.vue')
    }, {
        path: 'loops',
        name: 'content.loops',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'core.routes.content.loops'
        },
        component: () => import('./views/content/LoopsView.vue')
    }, {
        path: 'shared/:loopId',
        name: 'content.shared-loop',
        meta: {
            index: 1,
            code: 'core.routes.content.shared-loop',
            breadcrumbs: true
        },
        component: () => import('./views/content/SharedLoopView.vue')
    }, {
        path: 'shared',
        name: 'content.shared',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'core.routes.content.shared'
        },
        component: () => import('./views/content/SharedView.vue')
    }, {
        path: 'favorites',
        name: 'content.favorites',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'core.routes.content.favorites'
        },
        component: () => import('./views/content/FavoritesView.vue')
    }, {
        path: 'media',
        name: 'content.media',
        meta: {
            showInTabs: true,
            index: 3,
            code: 'core.routes.content.media'
        },
        component: () => import('./views/content/MediaView.vue')
    }]
}, {
    path: 'digital-signage/designs',
    name: 'designs',
    meta: {
        showInMenu: true,
        categoryIndex: 2,
        index: 2,
        licenses: {
            operator: 'and',
            licenses: [License.SPOT_VIDEO]
        },
        prependIcon: 'icon-template',
        code: 'core.routes.menu.designs'
    },
    component: () => import('./views/DesignsView.vue')
}, {
    path: 'digital-signage/studio/:designId',
    name: 'studio',
    meta: {
        code: 'core.routes.studio',
        hideNavigationMenu: true,
        alterApplicationBar: true
    },
    component: () => import('./views/StudioView.vue')
}];